import type { RouterOutputs } from "@repo/api";
import type { ReactNode } from "react";
import { useEffect } from "react";
import { useShallow } from "zustand/react/shallow";

import OrderChartDialog from "~/components/order-chart/order-chart-dialog";
import { CourseContext } from "~/hooks/use-course";
import { api } from "~/lib/api";
import { useLoadingStore } from "~/stores/use-loading-store";
import { UnsavedChangesProvider } from "./unsaved-changes-provider";

export type Course = RouterOutputs["course"]["getAll"][number];

interface CourseProviderProps {
  children: ReactNode;
}

export const CourseProvider = ({ children }: CourseProviderProps) => {
  const { data: courses, isFetching: isCoursesLoading } =
    api.course.getAll.useQuery(undefined, {
      initialData: [],
    });

  const { setLoadingStage } = useLoadingStore(
    useShallow((state) => ({
      setLoadingStage: state.setCurrentLoadingStage,
    })),
  );

  useEffect(() => {
    if (isCoursesLoading) {
      setLoadingStage("courses");
    } else {
      setLoadingStage(undefined);
    }
  }, [isCoursesLoading, setLoadingStage]);

  const context = {
    courses,
  };

  return (
    <CourseContext.Provider value={context}>
      <UnsavedChangesProvider>
        <OrderChartDialog />
      </UnsavedChangesProvider>
      {children}
    </CourseContext.Provider>
  );
};
